import { render, staticRenderFns } from "./DraggableColorPicker.vue?vue&type=template&id=4ddb0e17&scoped=true"
import script from "./DraggableColorPicker.vue?vue&type=script&lang=js"
export * from "./DraggableColorPicker.vue?vue&type=script&lang=js"
import style0 from "./DraggableColorPicker.vue?vue&type=style&index=0&id=4ddb0e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb0e17",
  null
  
)

export default component.exports